import OaApiService from './OaApiService';

export default class ArticleService extends OaApiService {
  getSnippets(data) {
    return this.get('/ArticleREST/snippet/search', data);
  }
}
